import React from 'react'
import { cn } from 'src/shared/components/ui/utils'

interface NavbarProps {
  children: React.ReactNode
  className?: string
  variant?: 'light' | 'dark'
  /** Sticky full-width bar on home (`/`). */
  overlayNav?: boolean
}

export const Navbar = ({
  children,
  className,
  variant = 'light',
  overlayNav = false,
}: NavbarProps) => {
  return (
    <div
      className={cn(
        overlayNav
          ? 'sticky top-0 z-[100] w-full shrink-0 bg-white/40 backdrop-blur-xl'
          : 'relative z-[100] w-full shrink-0 bg-white/40 backdrop-blur-xl',
        className
      )}
    >
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(
              child as React.ReactElement<{ variant?: 'light' | 'dark' }>,
              { variant }
            )
          : child
      )}
    </div>
  )
}
